import PropTypes from 'prop-types';
import React from 'react';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import Heading from '@bibliocommons/heading';

import { FullScreenOverlayContainer } from 'app/components/shared/FullScreenOverlay';
import { fieldShape } from 'app/shapes/browse';
import Field from '../shared/Field';
import ShowMoreOverlay from '../shared/ShowMoreOverlay';

import './Desktop.scss';

const DesktopFacets = ({ accessibilityHeading, fields, handleFilterChange, isFetching, setShowMoreFieldId }) => {
  const handleShowMoreOverlayClose = () => {
    setShowMoreFieldId(null);
  };

  const handleShowMoreClick = fieldId => {
    setShowMoreFieldId(fieldId);
  };

  const showMoreField = fields.find(field => field.isShowingMore);

  return (
    <div className="cp-facets-desktop">
      <ScreenReaderMessage>
        <Heading tagName="h2">{accessibilityHeading}</Heading>
      </ScreenReaderMessage>
      {!showMoreField && (
        <ul className="field-list">
          {fields.map(field => {
            if (field.isHidden) {
              return null;
            }

            return (
              <li className="field-item" key={field.fieldId}>
                <Field
                  field={field}
                  handleFilterChange={handleFilterChange}
                  handleShowMoreClick={handleShowMoreClick}
                  key={field.fieldId}
                />
              </li>
            );
          })}
        </ul>
      )}
      {showMoreField && (
        <FullScreenOverlayContainer
          dataKey="facets-show-more-overlay"
          handleClose={handleShowMoreOverlayClose}
          open={Boolean(showMoreField)}
          overlayKey="facets-show-more-overlay"
        >
          <ShowMoreOverlay
            group={showMoreField.groups[0]}
            handleFilterChange={handleFilterChange}
            isFetching={isFetching}
            renderBackButton={() => null}
            title={showMoreField.showMoreOverlayTitle}
          />
        </FullScreenOverlayContainer>
      )}
    </div>
  );
};

DesktopFacets.propTypes = {
  accessibilityHeading: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(fieldShape).isRequired,
  handleFilterChange: PropTypes.func.isRequired,
  isFetching: PropTypes.bool.isRequired,
  setShowMoreFieldId: PropTypes.func.isRequired
};

export default DesktopFacets;
